
import { connectRouter } from 'connected-react-router'
import { combineReducers } from 'redux';

import adminOrdersList from './adminOrdersList';
import adminOrderTypeCount from './adminOrderTypeCount';
import agronomyReferenceSheetList from './agronomyReferenceSheetList';
import blankList from './blankList'
import createProductState from './createProductState';
import document from './document';
import documentList from './documentList';
import statesList from './statesList';
import editor from './editor';
import fillerImageList from './fillerImageList'
import loading from './loading';
import options from './options';
import orderCostReport from './orderCostReport';
import orderCreated from './orderCreated';
import ordersList from './orderList';
import orderPlacedReport from './orderPlacedReport';
import storedRoute from './storedRoute';
import user from './user';
import wizard from './wizard';
import userDownloadList from './userDownloadList';
import productList from './productList';
import seedList from './seedList';
import productIconsList from './productIconsList';
import productLogosList from './productLogosList';
import seedCategoryList from './seedCategoryList';
import seedIconList from './seedIconList';
import seedDividerList from './seedDividerList';
import shelfDividerList from './shelfDividerList';
import techSheetList from './techSheetList';

export default (history: any) => combineReducers({
  router: connectRouter(history),
  adminOrdersList,
  adminOrderTypeCount,
  agronomyReferenceSheetList,
  blankList,
  createProductState,
  document,
  wizard,
  editor,
  documentList,
  fillerImageList,
  orderCostReport,
  orderCreated,
  ordersList,
  orderPlacedReport,
  statesList,
  loading,
  options,
  productList,
  storedRoute,
  userDownloadList,
  productIconsList,
  productLogosList,
  seedList,
  seedCategoryList,
  seedIconList,
  seedDividerList,
  shelfDividerList,
  techSheetList,
  user,
});



// WEBPACK FOOTER //
// ./src/reducers/index.tsx